import React, { useMemo, useState } from 'react';
import { Card, RadioGroup } from '@dopomogai/ui';
import type { AgentPerformanceMetrics } from '@dopomogai/types';

type Props = {
  baseMetrics?: AgentPerformanceMetrics | null;
  totalSupplyShares?: number;
  roundTotalShares?: number;
};

export function Projections({ baseMetrics, totalSupplyShares, roundTotalShares }: Props) {
  const [scenario, setScenario] = useState<'conservative' | 'base' | 'ambitious'>('base');

  const monthlyPayout = useMemo(() => {
    const earnings = baseMetrics?.total_earnings_credits ?? 1000;
    const multiplier = scenario === 'conservative' ? 0.6 : scenario === 'ambitious' ? 1.6 : 1.0;
    return Math.round(earnings * multiplier * 0.1);
  }, [baseMetrics, scenario]);

  return (
    <section className="max-w-6xl mx-auto px-6 py-8">
      <Card>
        <div className="p-4 space-y-4">
          <div className="text-xl font-extrabold">Illustrative projections</div>
          <RadioGroup
            label="Scenario"
            options={[
              { value: 'conservative', label: 'Conservative' },
              { value: 'base', label: 'Base' },
              { value: 'ambitious', label: 'Ambitious' },
            ]}
            value={scenario}
            onChange={(v) => setScenario((v as any) || 'base')}
          />
          <div className="text-slate-700 text-sm">Estimated monthly distributable pool (credits): <span className="font-bold">{monthlyPayout}</span></div>
          <div className="text-xs text-slate-600">Illustrative only. Not guaranteed. For education, not forecasts.</div>
        </div>
      </Card>
    </section>
  );
}


